import { _ as _type_of } from "@swc/helpers/_/_type_of";
export var cssFromObject = function(object) {
    return (typeof object === "undefined" ? "undefined" : _type_of(object)) === "object" ? Object.keys(object).map(function(key) {
        return "".concat(key, ": ").concat(object[key], ";");
    }).join("\n") : "";
};
